
import { useState } from 'react'
import { useLocation } from '@remix-run/react'

import navigation from '~/config/navigation.json'

import useApp from '~/hooks/useApp'
import useScope from '~/hooks/useScope'

import * as Styled from './style'
import type * as Types from './types'

const NavigationBar: Types.NavigationBarComponent = () => {
    const scope = useScope()
    const location = useLocation()
    const {
        id: appId,
    } = useApp()

    const [active, setActive] = useState<number>(location.pathname.includes('minnas') ? 1 : 0)

    const result = navigation.filter(obj => {
        return obj.name === appId
    })

    return (
        <Styled.Wrapper>
            <Styled.InnerWrapper>
                {result[0]?.children.map((child, index) => {
                    if (!child?.href.includes('https')) {
                        return (
                            <Styled.Link
                                key={child.href}
                                onClick={() => setActive(index)}
                                $active={index === active}
                                to={child.href}
                            >
                                {child.name}
                            </Styled.Link>
                        )
                    } else {
                        return (
                            <Styled.Anchor
                                key={child.href}
                                target={'_blank'}
                                href={child.href.replace('%scopeName', `${scope.id}`)}
                            >
                                {child.name}
                            </Styled.Anchor>)
                    }
                })}
            </Styled.InnerWrapper>
        </Styled.Wrapper>
    )
}

export default NavigationBar